var _defs, _polygon, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIconBlackCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 237.39999 237.39999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #010202;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "71.36005 65.36783 151.7962 171.6138 166.03992 171.6138 85.60382 65.36783 71.36005 65.36783"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.70001-.00003C53.09998-.00003,0,53.10001,0,118.69998s53.09998,118.70001,118.70001,118.70001,118.70001-53.10004,118.70001-118.70001S184.20001-.00003,118.70001-.00003ZM145.54169,184.16269l-34.10162-45.04376-38.40442,45.46216h-23.46039l50.77667-60.10828L46.10498,52.81894h45.7533l32.62244,43.09039,35.69415-42.25366h23.46033l-48.06464,56.89813-.099-.12714,55.82349,73.73602h-45.75336Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIconBlackCircle);
export default __webpack_public_path__ + "static/media/twitter-icon-black-circle.5832abe2d2cdb99e2fa7faa65c0c16aa.svg";
export { ForwardRef as ReactComponent };